"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var PayCodeResource = /** @class */ (function (_super) {
    tslib_1.__extends(PayCodeResource, _super);
    function PayCodeResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PayCodeResource.endpoint = '/paycodes';
    PayCodeResource.MODEL_NAME = 'paycode';
    return PayCodeResource;
}(base_1.default));
exports.default = PayCodeResource;
//# sourceMappingURL=paycode.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/system/paycode.js
// module id = TdOV
// module chunks = 0